import React, { useContext } from 'react';

import { GreetingModel } from '../../../../../../types/app';
import { InitialContext } from '../../app';
import { BadgeIndividualView, BadgeGroupView } from '@/components/views';
import { BaseTemplate } from '@/components/templates';
import { SocketWrapper } from '@/components/socket.tsx';

interface GreetingProps {
  data: GreetingModel;
};

export const GreetingPage: React.FC<GreetingProps> = (props) => {
  const greeting = useContext(InitialContext);

  const renderView = () => {
    switch (greeting.view) {
      case 'individual':
        return <BadgeIndividualView greeting={greeting} />
      case 'group':
        return <BadgeGroupView greeting={greeting} />
      default:
        return null;
    }
  };

  return (
    <SocketWrapper>
      <BaseTemplate>
        {greeting && renderView()}
      </BaseTemplate>
    </ SocketWrapper>
  );
};
